// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___1DTyI","m-signature-pad--body":"styles__m-signature-pad--body___1ZsYz","m-signature-pad--footer":"styles__m-signature-pad--footer___20-0E","description":"styles__description___3kN9v","button":"styles__button___alTLO","clear":"styles__clear___2qouw","save":"styles__save___5B3zX","m-signature-pad":"styles__m-signature-pad___3kAnk","github":"styles__github___149YN","close":"styles__close___3N_9z","submitBtnContainer":"styles__submitBtnContainer___2rwmj","checklistHeading":"styles__checklistHeading___bjwhy"};


//////////////////
// WEBPACK FOOTER
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseMaterialsChecklist/styles.scss
// module id = g4rU
// module chunks = client